import { h } from 'preact'
import PropTypes from 'prop-types'

import classNames from 'lib/classNames'
import './index.sass'

export default function ContentBox({
  className, padded, noBorder, children, ...props
}){
  return <div
    className={classNames('ContentBox', {padded, noBorder, className})}
    {...props}
  >{children}</div>
}

ContentBox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  padded: PropTypes.bool,
  noBorder: PropTypes.bool,
}

ContentBox.defaultProps = {
  padded: false,
  noBorder: false,
}
